/**
 * Categoriile blogului (etapa 8, 25.09.2026): 13 → 6.
 * Ordinea de afișare e cea din BLOG_CATEGORIES.
 * LEGACY_BLOG_CATEGORY mapează valorile vechi (linkuri ?blogCategory=...) la cele noi.
 */
export const BLOG_CATEGORIES = [
  "Cumpărare și vânzare",
  "Mărci și modele",
  "Costuri",
  "Piață și reglementări",
  "Orașe",
  "Mașini electrice",
] as const;

export const LEGACY_BLOG_CATEGORY: Record<string, string> = {
  "Ghiduri de cumpărare": "Cumpărare și vânzare",
  "Verificări auto": "Cumpărare și vânzare",
  "Sfaturi cumpărare": "Cumpărare și vânzare",
  "Siguranță": "Cumpărare și vânzare",
  "Sfaturi vânzare": "Cumpărare și vânzare",
  "Ghiduri BMW": "Mărci și modele",
  "Comparații auto": "Mărci și modele",
  "Top-uri auto": "Mărci și modele",
  "Finanțare": "Costuri",
  "Asigurări": "Costuri",
  "Întreținere": "Costuri",
  "Analize piață": "Piață și reglementări",
  "Ghiduri pe orașe": "Orașe",
  "Ghiduri mașini electrice": "Mașini electrice",
};

/** Returnează categoria nouă pentru o valoare veche; altfel valoarea neschimbată. */
export function normalizeBlogCategory(value: string): string {
  return LEGACY_BLOG_CATEGORY[value] ?? value;
}
